import React from "react";
import { RCCBadge, RCCHidden } from "react-common-components";
import { useHistory } from "react-router-dom";
import { useTranslation } from "src/context/Translations/context";
import { IDashboardActionsData } from "../interface";

interface ILI{
  data?: IDashboardActionsData;
	origin?: string;
	myActions?: boolean; 
}

const Li: React.FC<ILI> = ({
	data,
	origin,
	myActions
}) => {
	const { translate } = useTranslation();
	const history = useHistory();
    
	return (
		<>
			<div>
				<RCCBadge color="purple" layout="isSquare" onClick={() => history.push(myActions ? "/actions/panel/?group=27&myActions=true&situation=0&delayed=0"  :  `/actions/panel/?group=27&filterOrigin=${origin}&situation=0&delayed=0`)} >{data?.notStarted || 0}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Não iniciadas")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="blue" layout="isSquare" onClick={() => history.push(myActions ? "/actions/panel/?group=27&myActions=true&situation=1&delayed=0" : `/actions/panel/?group=27&filterOrigin=${origin}&situation=1&delayed=0`)} >{data?.inProgress || 0}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Em andamento")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="red" layout="isSquare" onClick={() => history.push(myActions ? "/actions/panel/?group=27&myActions=true&situation=1,0&delayed=1" : `/actions/panel/?group=27&filterOrigin=${origin}&situation=1,0&delayed=1`)} >{data?.dueDateExpired || 0}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Atrasadas")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="green" layout="isSquare" onClick={() => history.push(myActions ? "/actions/panel/?group=27&myActions=true&situation=2" : `/actions/panel/?group=27&filterOrigin=${origin}&situation=2`)} >{data?.finished || 0}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Concluídas")}
				</RCCHidden>
			</div>
		</>
	);
};

export default Li;
